/*
  rte-table-scroll.js — Tabellen in Blog-Artikeln und Seiten lesbar halten.

  Problem: base.css setzt `.rte table { table-layout: fixed }`. Breite Tabellen
  (bis zu 11 Spalten) bekommen dadurch je Spalte exakt 1/n der Textbreite; der
  Inhalt passt nicht mehr hinein und läuft sichtbar in die Nachbarspalte.
  Der in manchen Artikeln vorhandene overflow-x-Wrapper konnte nie greifen,
  weil die Tabelle durch width:100% nie breiter als ihr Container wird.

  Lösung: Tabellen ab 4 Spalten bekommen eine spaltenabhängige Mindestbreite
  und einen Container, der auf dem Desktop aus der schmalen Lesespalte
  ausbricht und ansonsten horizontal scrollt. Schmale Tabellen (bis 3 Spalten,
  z. B. die Batterie-Kompatibilitätslisten) bleiben unverändert.
  Produktbeschreibungen sind ausgenommen — die haben ihren eigenen Fix (#276).

  Angelegt: 09.09.2026
*/
(function () {
  var MIN_COLS = 4; // ab so vielen Spalten wird umgebaut
  var PX_PER_COL = 100; // Mindestbreite je Spalte
  var FIRST_COL_BONUS = 95; // erste Spalte trägt meist den langen Namen

  function countColumns(table) {
    var max = 0;
    var rows = table.rows;
    for (var i = 0; i < rows.length && i < 5; i++) {
      var n = 0;
      var cells = rows[i].cells;
      for (var j = 0; j < cells.length; j++) n += cells[j].colSpan || 1;
      if (n > max) max = n;
    }
    return max;
  }

  function enhance(table) {
    if (table.getAttribute('data-ak-table') === '1') return;
    table.setAttribute('data-ak-table', '1');

    var cols = countColumns(table);
    if (cols < MIN_COLS) return;

    var minW = FIRST_COL_BONUS + cols * PX_PER_COL;
    table.style.minWidth = minW + 'px';

    // Vorhandenen Scroll-Wrapper aus dem Artikel-HTML wiederverwenden,
    // statt einen zweiten darüberzusetzen.
    var wrap = null;
    var parent = table.parentElement;
    if (parent && parent !== document.body && parent.children.length === 1) {
      var ox = window.getComputedStyle(parent).overflowX;
      if (ox === 'auto' || ox === 'scroll') wrap = parent;
    }
    if (!wrap) {
      wrap = document.createElement('div');
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    }
    wrap.classList.add('ak-table-scroll');

    // Braucht die Tabelle mehr Platz als die Lesespalte hergibt, darf sie
    // auf dem Desktop aus ihr ausbrechen — höchstens bis zur Seitenbreite.
    if (minW > wrap.clientWidth + 1) {
      wrap.style.setProperty('--ak-table-w', minW + 'px');
      wrap.classList.add('ak-table-scroll--wide');
    }
  }

  function run() {
    var scopes = document.querySelectorAll('.rte:not(.product__description)');
    for (var i = 0; i < scopes.length; i++) {
      if (scopes[i].closest('.product__description')) continue;
      var tables = scopes[i].querySelectorAll('table');
      for (var j = 0; j < tables.length; j++) enhance(tables[j]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
